module.exports = __webpack_public_path__ + "img/assessment_card.a78aea7f.jpg";